import { render, staticRenderFns } from "./SwitchMicrophone.vue?vue&type=template&id=bf1181a0&"
import script from "./SwitchMicrophone.vue?vue&type=script&lang=ts&"
export * from "./SwitchMicrophone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports